// extracted by mini-css-extract-plugin
export default {"main":"#5c67ff","mainBack":"#ecf2fc","mainBack2":"#b1c6ff","skyBlue":"#eff5ff","skyBlue2":"#c3d4ff","orange":"#ff835b","orangeLight":"#fff4e8"};